module.exports = __webpack_public_path__ + "01ea978f/img/cadBim.e369a02a.png";